import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Dictionary } from '../../models/models';
import { DictionaryService } from '../../services/dictionary.service';

@Component({
  selector: 'modal-search-offer-component',
  templateUrl: './modal-search-offer.component.html',
})
export class ModalSearchOfferComponent implements OnInit {
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  statuses: Dictionary[];
  offerKinds: Dictionary[];
  statusName: string;
  offerKindName: string;
  @Input() statusId: string;
  @Input() offerKindId: string;
  @Input() dateStart: Date;
  @Input() dateEnd: Date;

  constructor(public activeModal: NgbActiveModal, private dictionaryService: DictionaryService) {}

  ngOnInit() {
    this.dictionaryService.getStatuses().subscribe((res) => {
      this.statuses = res;
      if (!this.statusId) {
        this.statusId = '';
      }
    });
    this.dictionaryService.getOfferKinds().subscribe((res) => {
      this.offerKinds = res;
      if (!this.offerKindId) {
        this.offerKindId = '';
      }
    });
  }

  search() {
    for (let i = 0; i < this.statuses.length; i++) {
      if (this.statuses[i].value.toString() == this.statusId) {
        this.statusName = this.statuses[i].name;
      }
    }

    for (let i = 0; i < this.offerKinds.length; i++) {
      if (this.offerKinds[i].value.toString() == this.offerKindId) {
        this.offerKindName = this.offerKinds[i].name;
      }
    }

    this.passEntry.emit({
      statusId: this.statusId,
      offerKindId: this.offerKindId,
      statusName: this.statusName,
      offerKindName: this.offerKindName,
      dateStart: this.dateStart,
      dateEnd: this.dateEnd,
    });
    this.activeModal.close();
  }

  clearSearch() {
    this.statusId = null;
    this.offerKindId = null;
    this.statusName = null;
    this.offerKindName = null;
    this.dateStart = null;
    this.dateEnd = null;
    this.search();
  }
}
